var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container"},[_c('h1',{staticClass:"title date fancy has-text-centered-mobile"},[_vm._v(_vm._s(_vm.todaysDate))]),_vm._v(" "),_c('line-form',{attrs:{"handle-submit":_vm.addLine}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }